var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSun = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 22,
  height: 22,
  viewBox: "0 0 22 22"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M.5 11.9v-1.8h2.6v1.8zM2.9 4.2l1.3-1.3L6 4.8 4.8 6zM10.1.5h1.8v2.6h-1.8zM17.8 2.9l1.3 1.3L17.2 6 16 4.8zM21.5 10.1v1.8h-2.6v-1.8zM19.1 17.8l-1.3 1.3-1.8-1.9 1.2-1.2zM11.9 21.5h-1.8v-2.6h1.8zM4.2 19.1l-1.3-1.3L4.8 16 6 17.2zM11 17.1c-3.4 0-6.1-2.7-6.1-6.1S7.6 4.9 11 4.9s6.1 2.7 6.1 6.1-2.7 6.1-6.1 6.1m0-1.7c2.4 0 4.4-2 4.4-4.4s-2-4.4-4.4-4.4-4.4 2-4.4 4.4 2 4.4 4.4 4.4"
})));
export default SvgSun;